import React from 'react';
import { IoCloseCircleOutline } from 'react-icons/io5';

// Normal Wi-Fi icon
const WifiIcon = ({ className = "" }) => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 16 16" 
    fill="#0078d2" 
    xmlns="http://www.w3.org/2000/svg" 
    aria-hidden="true"
    className={className}
  >
    <g clipPath="url(#clip0_11362_36987)">
      <path d="M15 6.35L14.25 7.05C12.8 5.2 10.55 4 8 4C5.45 4 3.2 5.2 1.75 7.05L1 6.35C2.65 4.3 5.2 3 8 3C10.8 3 13.35 4.3 15 6.35ZM8 5.5C5.9 5.5 4 6.5 2.8 8.05L3.55 8.75C4.55 7.4 6.15 6.5 8 6.5C9.85 6.5 11.45 7.4 12.45 8.75L13.2 8.05C12 6.5 10.1 5.5 8 5.5ZM8 8C6.6 8 5.35 8.7 4.65 9.8L5.4 10.5C5.9 9.6 6.9 9 8 9C9.1 9 10.1 9.6 10.6 10.5L11.35 9.8C10.65 8.7 9.4 8 8 8ZM8 10.5C7.3 10.5 6.7 10.95 6.55 11.6L8 13L9.45 11.6C9.3 10.95 8.7 10.5 8 10.5Z" />
    </g>
    <defs>
      <clipPath id="clip0_11362_36987">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// High-speed Wi-Fi icon
const HighSpeedWifiIcon = ({ className = "" }) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px" 
    width="16" 
    height="16" 
    viewBox="0 0 32 32" 
    fill="#0078d2" 
    aria-hidden="true"
    className={className}
  >
    <g>
      <rect width="32" height="32" fill="none" />
      <path d="M16,18c-2.2,0-4.2,1.2-5.2,3l-1.5-1.4c1.4-2.2,3.9-3.6,6.7-3.6c1.5,0,2.9,0.4,4.1,1.2c-0.8,0.4-1.6,0.8-2.3,1.1
        C17.3,18.1,16.6,18,16,18z M23.2,15.7c0.7-0.3,1.4-0.7,1.9-0.9C22.8,12.4,19.6,11,16,11c-4.2,0-8,2-10.4,5.1l1.5,1.4
        c2-2.8,5.2-4.5,8.9-4.5C18.8,13,21.3,14,23.2,15.7z M16,6C10.4,6,5.3,8.6,2,12.7l1.5,1.4C6.4,10.4,10.9,8,16,8
        c4.8,0,9.1,2.1,12,5.4l1.9-0.9C26.6,8.6,21.6,6,16,6z M14.2,21.6c1.4-1.1,13.7-6.8,13.7-6.8s-8.6,10.5-10,11.6
        C17.3,26.8,16.6,27,16,27c-0.9,0-1.8-0.4-2.3-1.2C12.6,24.5,12.9,22.6,14.2,21.6z M15.2,24.6c0.2,0.2,0.5,0.4,0.8,0.4
        c0.2,0,0.4,0,0.6-0.2c0.4-0.3,1.9-2,3.8-4.2c-2.6,1.3-4.6,2.3-5,2.6c-0.3,0.2-0.4,0.5-0.4,0.7C15,24,15,24.3,15.2,24.6z" />
    </g>
  </svg>
);

const AcPowerIcon = ({ className = "" }) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px" 
    width="16" 
    height="16" 
    viewBox="0 0 32 32" 
    fill="#0078d2" 
    aria-hidden="true"
    className={className}
  >
    <g>
      <path d="M13,8h-2V2h2V8z M21,2h-2v6h2V2z M17,28v-7h-5c-1.7,0-3-1.3-3-3v-7h14v7c0,1.7-1.3,3-3,3h-1v2h1c2.8,0,5-2.2,5-5v-7
        c0-1.1-0.9-2-2-2H9c-1.1,0-2,0.9-2,2v7c0,2.8,2.2,5,5,5h3v5c0,1.1,0.9,2,2,2h9v-2H17z" />
      <rect width="32" height="32" fill="none" />
    </g>
  </svg>
);

const UsbPowerIcon = ({ className = "" }) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    x="0px" 
    y="0px" 
    width="16" 
    height="16" 
    viewBox="0 0 32 32" 
    fill="#0078d2" 
    aria-hidden="true"
    className={className}
  >
    <g>
      <path d="M12,10h-2V2h12v8h-2V4h-8V10z M17,28v-4h-4c-1.7,0-3-1.3-3-3v-8h12v8c0,1.7-1.3,3-3,3v2c2.8,0,5-2.2,5-5v-8
      c0-1.1-0.9-2-2-2H10c-1.1,0-2,0.9-2,2v8c0,2.8,2.2,5,5,5h2v2c0,1.1,0.9,2,2,2h9v-2H17z M15,8V6h-2v2H15z M19,8V6h-2v2H19z" />
    </g>
  </svg>
);

const StreamingIcon = ({ className = "" }) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px" 
    width="16" 
    height="16" 
    viewBox="0 0 32 32" 
    fill="#0078d2" 
    aria-hidden="true"
    className={className}
  >
    <g>
      <rect width="32" height="32" fill="none" />
      <path d="M14,12l6,4l-6,4V12z M13,27h6v-1h-6V27z M25,4v24c0,1.1-0.9,2-2,2H9c-1.1,0-2-0.9-2-2V4c0-1.1,0.9-2,2-2h14
        C24.1,2,25,2.9,25,4z M23,4h-4v1c0,0.6-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1V4H9v13v11h14V4z" />
    </g>
  </svg>
);

const LiveTvIcon = ({ className = "" }) => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 16 16" 
    fill="#0078d2" 
    xmlns="http://www.w3.org/2000/svg" 
    aria-hidden="true"
    className={className}
  >
    <g clipPath="url(#clip0_11362_36995)">
      <path d="M12 3H4C2.35 3 1 4.35 1 6V10C1 11.65 2.35 13 4 13H12C13.65 13 15 11.65 15 10V6C15 4.35 13.65 3 12 3ZM6.15 6.2V10.5H5.05V6.2H3.45V5.4H7.15L7.4 6.2H6.15ZM10.8 10.5H9.45L7.7 5.4H8.85L10.15 9.45H10.2L11.5 5.4H12.6L10.8 10.5Z" />
    </g>
    <defs>
      <clipPath id="clip0_11362_36995">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const SeatbackEntertainmentIcon = ({ className = "" }) => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 16 16" 
    fill="#0078d2" 
    xmlns="http://www.w3.org/2000/svg" 
    aria-hidden="true"
    className={className}
  >
    <g clipPath="url(#clip0_11362_36991)">
      <path d="M9 8L12 10L9 12V8ZM7 7.1C6.85 7.05 6.7 7 6.5 7C5.65 7 5 7.65 5 8.5C5 9.35 5.65 10 6.5 10C7.35 10 8 9.35 8 8.5V2L3 3.25V8.6C2.85 8.55 2.7 8.5 2.5 8.5C1.65 8.5 1 9.15 1 10C1 10.85 1.65 11.5 2.5 11.5C3.35 11.5 4 10.85 4 10V4.5L7 3.75V7.1ZM14 6H8.5V7H14V13H6V10.5H5V13C5 13.55 5.45 14 6 14H14C14.55 14 15 13.55 15 13V7C15 6.45 14.55 6 14 6Z" />
    </g>
    <defs>
      <clipPath id="clip0_11362_36991">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const LieFlatSeatsIcon = ({ className = "" }) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px" 
    width="16" 
    height="16" 
    viewBox="0 0 32 32" 
    fill="#0078d2" 
    aria-hidden="true"
    className={className}
  >
    <g>
      <rect width="32" height="32" fill="none" />
      <path d="M29.6,29.2c-0.4,0.5-1,0.8-1.6,0.8H11v-2h17l-1.1-4H2v-2h12.6L9,2h4c1.3,0,2.5,0.9,2.9,2.2L19.7,18H28v2h-9.8L13.9,4.7
        C13.8,4.3,13.4,4,13,4h-1.3l5.1,18h11.6l1.6,5.5C30.1,28.1,30,28.7,29.6,29.2z M8.5,13.2l-1-1.7c-0.6,0.4-1.2,0.8-1.7,1.3l1.4,1.4
        C7.6,13.8,8,13.5,8.5,13.2z M6.5,14.9l-1.4-1.4c-0.5,0.5-0.9,1.1-1.3,1.7l1.7,1C5.8,15.7,6.1,15.3,6.5,14.9z M10.8,12.1l-0.5-1.9
        c-0.7,0.2-1.3,0.5-2,0.8l1,1.7C9.8,12.4,10.3,12.2,10.8,12.1z M5,17.1l-1.7-1c-0.3,0.6-0.6,1.3-0.8,2l1.9,0.5
        C4.6,18,4.8,17.6,5,17.1z M4.2,19.5L2.3,19c-0.1,0.6-0.2,1.3-0.2,2h2C4.1,20.5,4.1,20,4.2,19.5z" />
    </g>
  </svg>
);

const AppleMusicIcon = ({ className = "" }) => (
  <svg 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px" 
    width="16" 
    height="16" 
    viewBox="0 0 32 32" 
    fill="#0078d2" 
    aria-hidden="true"
    className={className}
  >
    <g>
      <g>
        <path d="M23,2H9C5.1,2,2,5.1,2,9v14c0,3.9,3.1,7,7,7h14c3.9,0,7-3.1,7-7V9C30,5.1,26.9,2,23,2z M28,23c0,2.8-2.2,5-5,5H9
          c-2.8,0-5-2.2-5-5V9c0-2.8,2.2-5,5-5h14c2.8,0,5,2.2,5,5V23z" />
        <path d="M12,20.2c-0.3-0.1-0.6-0.2-1-0.2c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3V12l6-1.5v6.7c-0.3-0.1-0.6-0.2-1-0.2
          c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3V7L12,9.5V20.2z" />
      </g>
      <rect width="32" height="32" fill="none" />
    </g>
  </svg>
);

const AmenitiesPopup = ({ amenities = [], onClose, position }) => {
  const iconMap = {
    wifi: { component: WifiIcon, label: 'Wi-Fi' },
    high_speed_wifi: { component: HighSpeedWifiIcon, label: 'High-speed Wi-Fi' },
    ac_power: { component: AcPowerIcon, label: 'AC power' },
    usb_power: { component: UsbPowerIcon, label: 'USB power' },
    streaming: { component: StreamingIcon, label: 'Personal device streaming' },
    live_tv: { component: LiveTvIcon, label: 'Live TV' },
    seatback_entertainment: { component: SeatbackEntertainmentIcon, label: 'Seatback entertainment' },
    lie_flat_seats: { component: LieFlatSeatsIcon, label: 'Lie-flat seats in Business and First only' },
    apple_music: { component: AppleMusicIcon, label: 'Apple Music' },
  };

  const filteredAmenities = amenities.filter(amenity => iconMap[amenity.toLowerCase()]);

  if (!filteredAmenities.length) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />
      
             {/* Popup - matching mat-mdc-dialog-surface structure */}
       <div 
         className="absolute z-50 bg-white w-80 block"
         style={{
           top: position.top,
           left: position.left,
           borderRadius: '4px',
           boxShadow: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)'
         }}
       >
        {/* Dialog content with grid-x structure */}
        <div className="flex flex-wrap bg-white p-5 items-center rounded" role="dialog" aria-modal="true">
          {/* Header - large-10 equivalent */}
          <div className="flex-grow">
            <span className="text-base font-bold text-[#36495a]">Onboard amenities</span>
          </div>
          
          {/* Close button - large-2 equivalent */}
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="text-[#0078d2] p-2 transition-all relative group flex items-center justify-center"
              title="Close window"
            >
              <IoCloseCircleOutline size={24} />
              <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-6 h-0.5 bg-[#0078d2] scale-x-0 group-hover:scale-x-100 transition-transform duration-200"></div>
            </button>
          </div>
          
          {/* Amenities List - full width with top padding */}
          <div className="w-full pt-2">
            <ul>
              {filteredAmenities.map((amenity) => {
                const { component: IconComponent, label } = iconMap[amenity.toLowerCase()];
                return (
                  <li key={amenity} className="flex items-center mb-1">
                    <div className="pr-2 flex items-center justify-center" style={{ width: '20px', height: '20px' }}>
                      <IconComponent className="w-8 h-8" />
                      <span className="sr-only">{label}</span>
                    </div>
                    <span className="text-gray-700 text-sm">{label}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AmenitiesPopup;